export const NHS = {
  NAME: 'nonghyup',
  NAMESPACE: (name) => `nonghyup/${name}`,
}

export const state = {
  paymentMethod: null,
}

export const mutations = {}

export const getters = {}

export const actions = {}
